import { render, staticRenderFns } from "./ProjectScopeCondensed.vue?vue&type=template&id=347e384e&scoped=true"
import script from "./ProjectScopeCondensed.vue?vue&type=script&lang=js"
export * from "./ProjectScopeCondensed.vue?vue&type=script&lang=js"
import style0 from "./ProjectScopeCondensed.vue?vue&type=style&index=0&id=347e384e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347e384e",
  null
  
)

export default component.exports